<template>
  <div>
    <div class="regularWarehouseBill">

      <div class="body">
        <div class="total">
          <!-- 总产品数 -->
          <div class="item" v-if="!isStockDetail">
            {{ $t('message.productNumber') }}: <span>{{ detail.goods_count }}</span>
          </div>
          <!-- 总箱数： -->
          <div class="item" v-if="!isStockDetail">
            {{ $t('message.boxNumber') }}: <span>{{ detail.box_count }}</span>
          </div>
          <div class="item" v-if="isStockDetail">
            总SKU数: <span>{{ detail.sku_count }}</span>
          </div>
          <!--总体积:  -->
          <div class="item">
            {{ $t('message.totalVolume') }}: <span>{{ detail.total_volume }}m³</span>
          </div>
          <!-- 总重量： -->
          <div class="item">
            {{ $t('message.totalWeight') }}: <span>{{ detail.total_weight }}kg</span>
          </div>
          <!-- 总费用： -->
          <div class="item">
            {{ $t('message.totalAmount') }}: <span>{{ detail.total_fee }}円</span>
          </div>
          <!-- 返回 -->
          <el-button type="primary" @click=" $parent.isDetail = false" size="small">
            {{ $t('message.return') }}
          </el-button>
        </div>
        <div class="table stock-table" v-if="isStockDetail">
          <ol style="background-color: #EDEFF4;">
            <li class="flex05">NO</li>
            <li>照片</li>
            <li>商品规格</li>
            <li>购入数据</li>
            <li class="flex2">尺寸.cm</li>
            <li>重量.kg</li>
            <li>仓库保管情报</li>
            <li>本日产生费用.円</li>
          </ol>
          <template v-if="orderGroups.length">
            <div class="stock-order" v-for="(group, groupIndex) in orderGroups" :key="groupIndex">
              <div class="order-head">
                <div>
                  订单号：
                  <router-link v-if="group.order_sn" :to="'/orderPaymentDetail?order_sn=' + group.order_sn"
                    class="a-link" target="_blank">
                    {{ group.order_sn }}
                  </router-link>
                  <span v-else>-</span>
                </div>
                <div class="subtotal">小计：<span>{{ group.subtotal_fee }}円</span>
                </div>
              </div>
              <ul v-for="(goods, goodsIndex) in group.lines" :key="goodsIndex">
                <li class="flex05">{{ goods.sorting }}</li>
                <li>
                  <el-image v-if="goods.pic" :src="goods.pic" fit="fill" :preview-src-list="[goods.pic]"
                    style="width: 60px; height: 60px;"></el-image>
                  <span v-else>-</span>
                </li>
                <li>
                  <div class="template">
                    <p v-for="(attr, attrIndex) in JSON.parse(goods.detail_y)" :key="attrIndex">
                      {{ attr.key }}: {{ attr.value }}
                    </p>
                  </div>
                </li>
                <li>
                  <div class="template">
                    <p>数量：<span class="blue">{{ goods.num }}</span></p>
                    <p>单价：<span>{{ goods.confirm_price || 0 }}</span> 元</p>
                    <p>国内运费：<span>{{ goods.confirm_freight || 0 }}</span> 元</p>
                    <p>小计：{{ (goods.num || 0) * (goods.confirm_price || 0) + (goods.confirm_freight || 0) }}元</p>
                  </div>
                </li>
                <li class="flex2">{{ goods.c }}*{{ goods.k }}*{{ goods.g }}</li>
                <li>{{ goods.weight }}</li>
                <li>
                  <div class="template">
                    <p>入库日：{{ goods.inbound_at }}</p>
                    <p>保管日数：{{ goods.storage_days }}日</p>
                  </div>
                </li>
                <li>{{ goods.total_fee }}</li>
              </ul>
            </div>
          </template>
          <div v-else class="empty">暂无数据</div>
        </div>
        <div class="table" v-else>
          <ol style="background-color: #EDEFF4;">
            <li class="flex05"></li>
            <li class="flex05">No</li>
            <!-- 箱号 -->
            <li>{{ $t('message.boxNumber') }}</li>
            <!-- 尺寸(cm) -->
            <li>{{ $t('message.dimension') }}</li>
            <!-- 重量(kg) -->
            <li>{{ $t('message.weight') }}(kg)</li>
            <!-- 箱内SKU数 -->
            <li>{{ $t('message.goodsCount') }}</li>
            <!-- 箱内商品数 -->
            <li>{{ $t('message.goodsNumber') }}</li>
            <!-- 常规仓储费-->
            <li>{{ $t('message.regularStorageFeeName') }}</li>
          </ol>
          <div class="detail" v-for="(item, index) in tableData" :key="index">
            <ul>
              <li class="flex05">
                <p style="margin-top: 10px;" class="isShow">
                  <!-- 展开收起 -->
                  <el-button type="info" @click="item.show = !item.show" size="mini">{{ item.show ?
                    $t('message.collapse') :
                    $t('message.expandCollapse') }}
                    <i v-if="!item.show" class="el-icon-arrow-down"></i>
                    <i v-else class="el-icon-arrow-up"></i>
                  </el-button>
                </p>
              </li>
              <li class="flex05">{{ index + 1 }}</li>
              <!-- 箱号 -->
              <li>{{ item.box_no }}</li>
              <!-- 尺寸(cm) -->
              <li>{{ item.c }}*{{ item.k }}*{{ item.g }}</li>
              <!-- 重量(kg) -->
              <li>{{ item.weight }}</li>
              <!-- 箱内SKU数 -->
              <li>{{ item.sku_count }}</li>
              <!-- 箱内商品数 -->
              <li>{{ item.goods_count }}</li>
              <!-- 常规仓储费-->
              <li>{{ item.total_fee }}</li>
            </ul>
            <el-collapse-transition>
              <div v-show="item.show" class="list">
                <ol style="background: #DCDFE6; color: #666666;">
                  <!-- 订单号 -->
                  <li>{{ $t('message.orderNumber') }}</li>
                  <!-- 番号 -->
                  <li>{{ $t('message.mash') }}</li>
                  <!-- 商品属性 -->
                  <li>{{ $t('message.commodityAttribute') }}</li>
                  <!-- 图片 -->
                  <li>{{ $t('message.pic') }}</li>
                  <!-- 数量 -->
                  <li>{{ $t('message.quantity') }}</li>
                </ol>
                <ul v-for="(goods, goodsIndex) in item.goods_list" :key="goodsIndex">
                  <!-- 订单号 -->
                  <li>
                    <router-link :to="'/orderPaymentDetail?order_sn=' + goods.order_sn" class="a-link" target="_blank">
                      {{ goods.order_sn }}
                    </router-link>
                  </li>
                  <!-- 番号 -->
                  <li>{{ goods.sorting }}</li>
                  <!-- 商品属性 -->
                  <li>
                    <div class="template">
                      <p v-for="(attr, attrIndex) in goods.detail_y" :key="attrIndex">
                        {{ attr.key }}: {{ attr.value }}
                      </p>
                    </div>
                  </li>
                  <!-- 图片 -->
                  <li>
                    <el-image :src="goods.pic" fit="fill" :preview-src-list="[goods.pic]"
                      style="width: 60px; height: 60px;"></el-image>
                  </li>
                  <!-- 数量 -->
                  <li>{{ goods.num }}</li>
                </ul>
              </div>
            </el-collapse-transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      tableData: [],
      orderGroups: [],
      detail: {},
      bill_id: '',
      detail_category: 'stock',
    }
  },
  components: {
  },
  computed: {
    isStockDetail() {
      return this.detail_category === 'stock'
    }
  },
  methods: {
    // 常规仓库账单-获取详情
    regularStorageBillDetail() {
      this.$api.costManagementApi.regularStorageBillDetail({
        bill_id: this.bill_id,
        detail_category: this.detail_category
      }).then(res => {
        let details = res.data.details || []
        details.forEach(item => {
          item.show = false
        })
        this.detail = res.data
        this.tableData = details
        this.orderGroups = res.data.order_groups || []
      })
    },
  }
}
</script>
<style scoped lang="scss">
.regularWarehouseBill {
  .total {
    display: flex;
    margin-bottom: 20px;
    position: relative;

    .el-button {
      position: absolute;
      right: 0;
    }

    .item {
      margin-right: 50px;
      color: #666666;

      span {
        font-weight: bold;
        margin-left: 5px;
        color: #333333;
      }
    }
  }

  .table {
    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 2;
    }

    ol {
      background: #DCDFE6;
      height: 56px;
      line-height: 56px;
      color: #666666;
    }

    ul {
      padding: 20px 0;
      background-color: #fff;
      text-align: center;

      p {
        line-height: 22px;
        margin-bottom: 6px;

        .el-button {
          width: 80px;
          padding: 11px 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .template {
      width: 100%;


      .row {
        margin-bottom: 12px;
      }
    }

    &.stock-table {
      border-left: 1px solid #EBEEF5;
      border-top: 1px solid #EBEEF5;

      ol,
      ul {
        border-bottom: 1px solid #EBEEF5;

        li {
          min-height: 80px;
          margin-right: 0;
          padding: 10px;
          border-right: 1px solid #EBEEF5;
          box-sizing: border-box;
        }

        .flex05 {
          flex: 0.6;
        }

        .flex2 {
          flex: 1.6;
        }
      }

      ul {
        padding: 0;
      }

      ol li {
        min-height: 56px;
      }

      .order-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 38px;
        padding: 0 34px 0 40px;
        border-right: 1px solid #EBEEF5;
        border-bottom: 1px solid #EBEEF5;
        background-color: #EFEFEF;

        .subtotal {
          font-weight: bold;

          span {
            margin-left: 18px;
          }
        }
      }

      .template {
        text-align: left;

        p {
          margin-bottom: 4px;
        }
      }

      .blue {
        color: blue;
        font-weight: bold;
      }

      .red {
        color: red;
      }

      .empty {
        height: 80px;
        line-height: 80px;
        text-align: center;
        color: #909399;
        border-right: 1px solid #EBEEF5;
        border-bottom: 1px solid #EBEEF5;
      }
    }
  }

  .isShow {
    text-align: left;

    .el-button {
      background-color: #F6F6F6;
      border: none;
      color: #999999;
      padding: 6px 10px;

      i {
        margin-left: 10px;
      }
    }
  }
}
</style>
